import { useCallback } from 'react'

export interface IUseKeyUpListener {
  onUp: (ev: KeyboardEvent) => any
  onDown: (ev: KeyboardEvent) => any
  onEscape: (ev: KeyboardEvent) => any
}

export const useKeyUpListener = ({ onUp, onDown, onEscape }: IUseKeyUpListener) => {
  return useCallback(
    function (this: Window, ev: KeyboardEvent) {
      if (ev.key === 'Escape') {
        onEscape(ev)
      }
      if (ev.key === 'ArrowUp') {
        onUp(ev)
      }
      if (ev.key === 'ArrowDown') {
        onDown(ev)
      }
    },
    [onUp, onDown, onEscape],
  )
}
